import { Component, ChangeDetectorRef, Input, Inject, OnInit } from '@angular/core';

import * as State from '@shared/state';
import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { TilesComponent } from '../../tiles.shared.component';

import { Observable } from 'rxjs';
import { IMenuFlowPage } from '@shared/state';

@Component({
    selector: 'shared-tile-for-wizzard',
    templateUrl: './tile-for-wizzard.shared.component.html',
    styleUrls: ['./tile-for-wizzard.shared.component.scss']
})
export class TileForWizzardComponent extends TilesComponent implements OnInit {
    public isOneAllowed: boolean = false;
    public isAvailable: boolean = false;

    @Input() public indicatorFeel: OLO.Components.INDICATOR_FEEL = 'positive-full';
    @Input() public indicatorSize: OLO.Components.BUTTON_SIZE = 'sm';
    @Input() public wizzardProduct: APICommon.IMenuFlowProduct;
    @Input() public page: IMenuFlowPage;

    public ingredientOptions$: Observable<Array<APICommon.IIngredientModifierExtended | OLO.Components.DropDown.IDropDownOption>>;
    public ingredientSelected$: Observable<APICommon.IIngredientModifierExtended | OLO.Components.DropDown.IDropDownOption>;
    public image$: Observable<State.IProductImage>;
    public isDisabled$: Observable<boolean>;
    public isSelected$: Observable<boolean>;
    public isClickable$: Observable<boolean>;
    public showRemoveForOneAllowed$: Observable<boolean>;
    public showQuantityButtons$: Observable<boolean>;
    public isPageLimitReached$: Observable<boolean>;
    public canShowNextPrice$: Observable<boolean>;
    public nextPriceForProduct$: Observable<number>;
    public quantity$: Observable<number>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
        const productId: number = this.wizzardProduct?.ProductId;
        const pageIdentifier: number = this.page?.PageIdentifier;

        this.image$ = this.controllers.images.wizzardMenuFlowProductImage$(productId);
        this.isAvailable = this.wizzardProduct?.State === 0;
        this.isOneAllowed = this.page?.PageMaxQuantity === 1;
        this.isDisabled$ = this.controllers.wizzard.isProductDisabled$(pageIdentifier, productId, this.wizzardProduct?.State);
        this.quantity$ = this.controllers.wizzard.menuFlowProductQuantity$(pageIdentifier, productId);
        this.isSelected$ = this.controllers.wizzard.isProductSelected$(pageIdentifier, productId);
        this.showRemoveForOneAllowed$ = this.controllers.wizzard.showRemoveButton$(pageIdentifier, productId);
        this.showQuantityButtons$ = this.controllers.wizzard.showCounterButtons$(pageIdentifier, productId);
        this.isClickable$ = this.controllers.wizzard.isMenuFlowProductSelectable$(pageIdentifier, productId, this.wizzardProduct?.State);
        this.isPageLimitReached$ = this.controllers.wizzard.isPageLimitReached$(pageIdentifier);
        this.canShowNextPrice$ = this.controllers.wizzard.canShowNextPrice$(pageIdentifier, this.wizzardProduct);
        this.nextPriceForProduct$ = this.controllers.wizzard.nextProductPrice$(pageIdentifier, productId);
        this.ingredientOptions$ = this.controllers.wizzard.getIngredientsForWizzardProductForDropdown$(this.wizzardProduct);
        this.ingredientSelected$ = this.controllers.wizzard.getSelectedIngredientForWizzardProduct$(pageIdentifier, productId);
    }

    public get canUseModifiers(): boolean {
        return !(this.config?.onlineOrders && this.config?.onlineOrders?.allowModifiers === false);
    }

    /* Wizzard */
    public handleWizzardProductClick($event: Event): void {
        if (!this.isAvailable) return;

        this.controllers.wizzard.handleWizzardMenuFlowProductClick(this.page.PageIdentifier, this.wizzardProduct);
    }

    public handleIncrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {

        $event.event.stopImmediatePropagation();
        this.controllers.wizzard.incrementMenuFlowProduct(this.page.PageIdentifier, this.wizzardProduct.ProductId);
    }

    public handleDecrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {

        $event.event.stopImmediatePropagation();
        this.controllers.wizzard.decrementMenuFlowProduct(this.page.PageIdentifier, this.wizzardProduct.ProductId);
    }

    public handleRemove($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        $event.event.stopImmediatePropagation();
        this.handleDecrement($event);
    }

    public onIngredientSelected($event: APICommon.IIngredientModifierExtended & OLO.Components.DropDown.IDropDownOption): void {
        this.controllers.wizzard.selectIngredientForWizzardMenuFlowProduct(this.page.PageIdentifier, this.wizzardProduct.ProductId, $event);
    }

    public stopPropagation($event: Event): void {
        $event.stopPropagation();
    }
}
